enum RoutePaths {
  Root = '/',
  RegisterForm = '/new-user',
  Register = '/register',
  Login = '/login',
  Home = '/dashboard',
  Client = '/clients',
  Team = '/team',
  Tasks = '/tasks',
  Deals = '/deals',
  Salesforce = '/salesforce',
  EmailVerification = '/verify-account',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  Terms = '/terms',
  Privacy = '/privacy',
  Asana = '/asana',
  Businesses = '/businesses',
  ZoomInfo = '/zoominfo',
  Leads = '/leads',
  Contacts = '/contacts',
}

export default RoutePaths;
